import { getBscGlobalState, isSSR } from '../../../common/utils';
import { ATLASSIAN_CONSENT_COOKIE_KEY, LEGACY_ATLASSIAN_GDPR_COOKIE_KEY } from '../../../constants';
import type { PrefetchedConsentPreferences } from '../../../services/consent-hub-service/types';
import type { ConsentPreference } from '../../../types';
import { getConsentToken } from '../../cookie-controls/get-consent-token';
import { getCookie } from '../../cookie-controls/get-cookie';
import { unpackUserPreferencesCookie } from '../../cookie-controls/transformer';

declare global {
	interface Window {
		__COOKIE_CONSENT_PREFERENCES__?: PrefetchedConsentPreferences | null;
	}
}

export async function getPreferences(): Promise<ConsentPreference | undefined> {
	// when localConsentMode is on, don't make calls to ConsentHub
	if (getBscGlobalState().localConsentMode) {
		const packedPrefs = getCookie(LEGACY_ATLASSIAN_GDPR_COOKIE_KEY);

		if (!packedPrefs) {
			return undefined;
		}

		return unpackUserPreferencesCookie(packedPrefs);
	} else {
		let packedLocalPrefs = getCookie(ATLASSIAN_CONSENT_COOKIE_KEY);

		if (!packedLocalPrefs) {
			const consentToken = await getConsentToken();
			if (isSSR() && consentToken) {
				window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(
					window.__COOKIE_CONSENT_PREFERENCES__ || {},
					{
						consentToken,
					},
				);
			}
			return consentToken ? unpackUserPreferencesCookie(consentToken) : undefined;
		}

		return unpackUserPreferencesCookie(packedLocalPrefs);
	}
}
